<div id="container-minerva">
  <ngb-carousel
    [showNavigationArrows]="false"
    [showNavigationIndicators]="false">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/minerva/minerva-website.png" alt="TSOLife" />
      </div>
      <div class="carousel-caption text-start">
        <h1>Use resident data to build meaningful relationships</h1>
        <h2 class="mt-4">
          Minerva is a powerful AI tool for senior living communities. From a
          single spoken interview with residents, Minerva captures thousands of
          data points that will help you make better operational decisions and
          enrich your residents’ lives.
        </h2>
        <a
          class="btn btn-danger btn-lg m-btn-schedule minerva-contact-btn cursor-pointer"
          href="https://get.tsolife.com/contact-us"
          >Contact Us To Learn More</a
        >
      </div>
    </ng-template>
  </ngb-carousel>

  <div class="card enhance-card">
    <div class="row justify-content-center mt-5 mb-5">
      <div class="col-10">
        <h2 class="text-center my-5">
          ENHANCE PERSONAL CONNECTIONS WITH ONE INTUITIVE TECHNOLOGY PLATFORM
        </h2>
        <p class="text-center my-2">
          Personalizing the resident experience is crucial in the senior living
          industry. TSOLife’s integrated platform makes the time-consuming task
          of collecting resident data a snap — then empowers you to personalize
          daily activities, match residents with likely friends who share their
          interests, and deliver friendly communications like birthday greetings
          or congratulations on sports team wins.
        </p>
      </div>
    </div>
  </div>

  <div class="card features-card p-5">
    <div class="col-10 mx-auto">
      <div class="col-12 d-flex flex-wrap mb-5 center-feature" id="blue-item">
        <!--Mobile case-->
        <div class="feature-mobile-case">
          <div class="row align-items-center">
            <img
              class="card-img img-fluid d-inline ms-auto"
              src="assets/images/minerva/icon1.png" />
            <h3 class="break-words d-inline me-auto">
              Simplified Resident Data Collection
            </h3>
          </div>
          <p>
            Record your intake interview, and AI will automatically build a
            detailed resident profile, capturing key interests and demographic
            details.
          </p>
        </div>
        <!--Web case-->
        <div class="feature-web-case col-12 d-flex flex-wrap">
          <img
            class="card-img img-fluid"
            src="assets/images/minerva/icon1.png" />
          <div class="col-9 my-auto ms-3">
            <h3>Simplified Resident Data Collection</h3>
            <p>
              Record your intake interview, and AI will automatically build a
              detailed resident profile, capturing key interests and demographic
              details.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex flex-wrap my-5 center-feature" id="green-item">
        <!--Mobile case-->
        <div class="feature-mobile-case">
          <div class="row align-items-center">
            <img
              class="card-img img-fluid d-inline ms-auto"
              src="assets/images/minerva/icon2.png" />
            <h3 class="break-words d-inline me-auto">
              Improved Resident Engagement and Satisfaction
            </h3>
          </div>
          <p>
            With integrated friend and interest matching, and real-time
            analytics on resident engagement, you can improve overall quality of
            life and retention.
          </p>
        </div>
        <!--Web case-->
        <div class="feature-web-case col-12 d-flex flex-wrap">
          <img
            class="card-img img-fluid"
            src="assets/images/minerva/icon2.png" />
          <div class="col-9 my-auto ms-3">
            <h3>Improved Resident Engagement and Satisfaction</h3>
            <p>
              With integrated friend and interest matching, and real-time
              analytics on resident engagement, you can improve overall quality
              of life and retention.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex flex-wrap my-5 center-feature" id="red-item">
        <!--Mobile case-->
        <div class="feature-mobile-case">
          <div class="row align-items-center">
            <img
              class="card-img img-fluid d-inline ms-auto"
              src="assets/images/minerva/icon3.png" />
            <h3 class="break-words d-inline me-auto">
              Smarter Corporate and Community Decisions
            </h3>
          </div>
          <p>
            Identify your ideal customer with business intelligence dashboards
            and get key insights about resident's preferences—for better
            marketing, sales, and resident experiences.
          </p>
        </div>
        <!--Web case-->
        <div class="feature-web-case col-12 d-flex flex-wrap">
          <img
            class="card-img img-fluid"
            src="assets/images/minerva/icon3.png" />
          <div class="col-9 my-auto ms-3">
            <h3>Smarter Corporate and Community Decisions</h3>
            <p>
              Identify your ideal customer with business intelligence dashboards
              and get key insights about resident's preferences—for better
              marketing, sales, and resident experiences.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="row justify-content-center card-home-page-quote card-image"
    style="background-image: url('assets/images/banners/quote-photo.jpg')">
    <div class="col-lg-8">
      <div class="row">
        <blockquote class="blockquote">
          <p>
            "I had a resident that approached me and wanted to play bridge but
            didn't know of anyone else interested in playing. I went to the
            dashboard, was delighted to see bridge under activities, and
            instantly came back with a list of names of people to invite to a
            bridge game."
          </p>
        </blockquote>
      </div>
    </div>
  </div>

  <div class="card card-home-page-white text-right gray-backgroud">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/banners/actionable-mockup-2.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 text-right">
        <div class="card-body pad-10">
          <h2 class="card-title mb-4 text-right img-info-title">
            Get meaningful data and insights for resident life enrichment
          </h2>
          <p class="card-text text-right img-info-body">
            Deliver the high-quality care and experience your residents deserve.
            With TSOLife's Actionable Resident Insights, staff members can use
            real-time data and notifications to create personalized touchpoints
            and enhance the lives of residents. Powerful analytic dashboards
            guide your programming to improve resident satisfaction and overall
            quality of life scores.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-home-page text-right gray-backgroud">
    <div class="row align-items-center text-right invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body pad-10 mtb-50 text-end">
          <h2 class="card-title mb-4 text-right img-info-title">
            Better understand your ideal customer profile
          </h2>
          <p class="card-text text-right img-info-body">
            Ensure your marketing and sales teams are targeting the best
            candidates for outreach based on demographics, interests, and
            hobbies of your current residents. Leverage your TSOLife dashboards
            to turn data from your existing resident profiles into consolidated
            marketing campaigns, and recruitment strategies.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="img-100"
          src="assets/images/banners/calendar-graph.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="card card-home-page-white text-right gray-backgroud">
    <div class="row">
      <div class="col-md-5 offset-md-1">
        <div class="card-body">
          <img
            class="card-img img-fluid rounded-5"
            src="assets/images/banners/community-portal.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 text-right">
        <div class="card-body pad-10 add-pad-bottom">
          <h2 class="card-title mb-4 text-right img-info-title">
            Streamline operations and maximize your business potential with
            Minerva’s AI technology
          </h2>
          <p class="card-text text-right img-info-body">
            Minerva’s corporate and community dashboards are more than just a
            simple replacement for your existing process — they're a
            game-changer for your business. By collecting hundreds of data
            points for each resident, including their likes, interests, needs,
            and goals, you'll have access to millions of data points that can
            help you make strategic business decisions that transform the
            resident experience.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-home-page-white text-center">
    <div class="container">
      <div class="row mtb-50 align-items-center">
        <div class="col-md-4 main-img">
          <img
            class="card-img-top img-fluid"
            src="assets/images/homepage/dashboard-mockup.png" />
        </div>
        <div class="col-md-7">
          <div>
            <h2 class="card-title engaged-section-title mt-0 text-center">
              READY TO BUILD A MORE ENGAGED, VIBRANT SENIOR LIVING COMMUNITY?
            </h2>
          </div>
          <a
            class="btn btn-lg btn-primary"
            href="https://get.tsolife.com/contact-us"
            >Schedule Demo</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
